import en from './en';

export enum locale {
  ENGLISH = 'en',
}

export default {
  [locale.ENGLISH]: en,
};
